/* Trick or Print — avvio del tema. Generato da sito/build/tema.py.

   Sul sito statico ogni pagina aveva il suo `contenuto()` scritto in fondo al file.
   Qui le pagine sono template di Shopify: chi decide e' `request.page_type`,
   che arriva in window.SHOPIFY.pagina.
*/

/* variante Shopify → id del sito (serve al carrello per sapere cosa c'e' dentro) */
function idDaVariante(v) {
  const p = CAT().prodotti.find(x => x.variante === v);
  return p ? p.id : null;
}

/* le onde fra una sezione e l'altra, dove non le riempie rifiniture() */
function onde() {
  $$(".onda").forEach(o => {
    if (!o.innerHTML.trim()) o.innerHTML = onda().replace(/^<div[^>]*>|<\/div>$/g, "");
  });
}

function amiciDiAbout() {
  const l = $("#lista-amici");
  if (!l) return;
  l.innerHTML = CAT().amici.map(a => `<div class="amico">
    <img src="${ASSET(`assets/img/friends/${a.id}.png`)}" alt="${a.nome}" loading="lazy">
    <h4>${a.nome} <span>(${a.pron})</span></h4><p>${a.testo}</p></div>`).join("");
}

function avviaTema() {
  if (!window.SHOPIFY || !window.CATALOGO) { console.error("dati mancanti"); return; }
  fondiPrezzi();                       // ⬅️ i prezzi di Shopify entrano nel catalogo

  const tipo = SHOPIFY.pagina, h = SHOPIFY.handle;
  window.contenuto = () => {
    try {
      if (tipo === "index") contenutoHome();
      else if (tipo === "collection") shop();
      else if (tipo === "product") prodotto();
      else if (tipo === "page" && h === "teachers") insegnanti();
      else if (tipo === "page" && h === "about") { chiSiamo(); amiciDiAbout(); }
      onde();
      $$(".rivela").forEach(e => e.classList.add("viva"));
    } catch (e) { console.error("contenuto()", e); }
  };

  // ⛔ I video non sono (ancora) nei File di Shopify: senza sorgente la sezione
  //    resta un riquadro vuoto, quindi si nasconde invece di mostrarla rotta.
  if (!Object.keys(TP_VIDEO).length) {
    const s = document.getElementById("sfogliare");
    if (s) s.style.display = "none";
    $$("video").forEach(v => { const r = v.closest(".video-riq") || v; r.style.display = "none"; });
  }

  avvia(location.pathname.replace(/\/$/, "") || "/");
}

document.addEventListener("DOMContentLoaded", avviaTema);
